/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)


// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

// Vue ACL
import acl from './acl/acl'

// VeeValidate
import VeeValidate, { Validator } from 'vee-validate'
import es from 'vee-validate/dist/locale/es'
// import dni from '@/assets/utils/dni.js'

// Validación DNI, CIF, NIF (https://github.com/coixinet/spain-id)
import { validateSpanishId } from 'spain-id'
import iban from '@/assets/utils/iban.js'

import VueCurrencyInput from 'vue-currency-input'

const pluginOptions = {
  /* https://dm4t2.github.io/vue-currency-input/config/#component */
  /* usamos DE pq añade los puntos en los miles, ES parece que no lo hace */
  globalOptions: { currency: null, locale: 'de-DE' }
}
Vue.use(VueCurrencyInput, pluginOptions)

Vue.use(VeeValidate)
Validator.localize('es', es)

const checkDNI = {
  getMessage (campo) {
    return `El ${campo} introducido es incorrecto.`
  },
  validate (valor) {
    if (valor) {
      return validateSpanishId(valor)
    } else {
      return false
    }
  }
}
Validator.extend('checkDNI', checkDNI)

Validator.extend('checkIBAN', {
  getMessage: field => `El ${field} introducido es incorrecto.`,
  validate: (value) => { return iban.validaIban(value) }
})


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  acl,
  render: h => h(App)
}).$mount('#app')
